import React, {useState} from "react";
import {useForm} from "react-hook-form";
import CustomerFields from "./CustomerFields";
import EditCustomerFields from "./EditCustomerFields";

export default function () {
    const {register, handleSubmit, reset, control, watch} = useForm({
        shouldUnregister: true,
    });
    const [errors, setErrors] = useState({});
    const customerFields = <CustomerFields {...{register, errors, control, watch}} />;
    const editCustomerFields = <EditCustomerFields {...{register, errors, control, watch}} />;

    return {
        setErrors,
        customerFields,
        editCustomerFields,
        handleSubmit,
        reset,
    }
}